// Template: resources/views/_components/admin/medium.blade.php

export default {
	data: () => (
		{
			showDeleteDialog: false,
            isDeleting: false
		}
	),

	props: {
		transition: {default: 'fade'},
        fit: false,
        sortable: false,
		medium: null,
        thumb: {type: String, default: 'square'} // or original
	},

    name: 'Medium',

    components: {},

	methods: {
        openEditor() {
            if (this.medium.type == 'icon') return;
            this.$bus.$emit('openMediaEditor', this.medium);
        },

		onDelete() {
            this.$bus.$emit('delete-medium', this.medium);
		},

		onClose() {
			this.$emit('edit-media-closed', true);
		},
	},

    computed: {
        mediumThumbnail() {
            if (this.medium.type == 'icon') {
                return 'data:image/svg+xml;utf8,' + this.medium.content;
            } else {
                return this.thumb == 'square' ? this.medium.thumb : this.medium.url;
            }
        }
    }
}
